import Cookies from 'js-cookie';
import { API, AUTH_API } from '@/services';
import { HelperFunctions } from '@/helpers';
import { Params } from '@/constants';
import store from '@/store';
import Auth from '@aws-amplify/auth';

export default {
  isAuthenticated: false,
  idToken: '',
  authCode: '',

  getCookie(): string | undefined {
    return Cookies.get(Params.COOKIE_KEY);
  },
  setCookie(urlToken: string): void {
    const TODAY = new Date();
    TODAY.setHours(TODAY.getHours() + 2);
    Cookies.set(Params.COOKIE_KEY, urlToken, { expires: TODAY });
  },
  deleteCookie(): void {
    Cookies.remove(Params.COOKIE_KEY);
    Cookies.remove('idToken');
    this.isAuthenticated = false;
  },
  authorizeUser(cookie: string): void {
    this.idToken = cookie;
    this.isAuthenticated = true;
    API.defaults.headers.Authorization = cookie;
    AUTH_API.defaults.headers.Authorization = cookie;
  },
  // Sign out the user
  async signOutUser(signedOut: boolean): Promise<void> {
    const API_PATH = process.env.VUE_APP_API_PATH;
    const API_VERSION = process.env.VUE_APP_API_VERSION;

    if (signedOut) {
        await API.delete(
            `${API_PATH}/${API_VERSION}/tokens`,
        );
    }

    // Delete cookie
    this.deleteCookie();

    // Only call amplify signout for those Partners federating through OIDC
    if (process.env.VUE_APP_COGNITO_PARTNER_PROVIDER !== 'horizon') {
        await Auth.signOut();
    }

    // Redirect user
    const signedOutString = signedOut ? '?signed_out=true&federated_sign_out=true' : '?signed_out=true';
    localStorage.clear();
    // Full page change, to clear memory
    window.location.href = `/portal/index.html${signedOutString}`;
  },
  async checkForToken(): Promise<void> {
    await store.Auth.dispatch('getUrlToken');
    const URL_TOKEN = localStorage.getItem('idToken')
      ? localStorage.getItem('idToken') : localStorage.getItem('JWT');
    const COOKIE = this.getCookie();
    if (URL_TOKEN) {
      this.setCookie(URL_TOKEN);
      this.authorizeUser(URL_TOKEN);
    } else if (COOKIE) {
      this.authorizeUser(COOKIE);
    } else if (HelperFunctions.getUrlParameter(Params.IDENTITY_PROVIDER)) {
      return;
    } else if (HelperFunctions.getUrlParameter(Params.AUTH_CODE)) {
      return;
    } else if (HelperFunctions.noURLParams()) {
      this.signOutUser(false);
    }
  },
};
